import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { Field, useFormikContext } from 'formik';
import React, { memo } from 'react';
import { useWebHook, useWebHookScreen } from 'v2/components/Pages/Webhook/context';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { WebhookTypes } from 'v2/interfaces/webhook/webhook';

import type { IWebHookFilter } from 'v2/interfaces/webhook/webhook';
const Fields = memo(() => {
  const { loading } = useWebHookScreen();
  const { setFiltersWebhook } = useWebHook();
  const { resetForm, dirty, isSubmitting, isValid } = useFormikContext<IWebHookFilter>();

  function onResetForm() {
    resetForm();
    setFiltersWebhook(null);
  }

  return (
    <Grid container spacing={2} direction='row' alignItems='flex-start' justify='space-between'>
      <Grid item xs={12} md={3}>
        <Field id='name' name='name' placeholder='Ex: Meu webhook' disabled={loading} label='Nome' fullWidth component={TextFormField} />
      </Grid>

      <Grid item xs={12} md={2}>
        <Field id='type' name='type' label='Tipo' fullWidth options={WebhookTypes} component={SelectFormField} />
      </Grid>

      <Grid item xs={12} md={4}>
        <Field
          id='url'
          name='url'
          placeholder='Ex: https://meu-site.com/webhook'
          disabled={loading}
          label='URL'
          fullWidth
          component={TextFormField}
        />
      </Grid>

      <Grid item xs={6} md={1} style={{ marginTop: 24 }}>
        <Button fullWidth disabled={!dirty || isSubmitting || loading} onClick={() => onResetForm()}>
          limpar
        </Button>
      </Grid>
      <Grid item xs={6} md={2} style={{ marginTop: 24 }}>
        <Button
          disabled={isSubmitting || loading || !isValid}
          startIcon={<Icon>filter_list</Icon>}
          type='submit'
          variant='contained'
          color='secondary'
          fullWidth
        >
          filtrar
        </Button>
      </Grid>
    </Grid>
  );
});

export default Fields;
